// Gallery Data
export const galleryData = {
  images: [
    {
      src: "/img/barret.jpg",
      original: "/img/barret.jpg",
      width: 465,
      height: 412,
    },
    {
      src: "/img/Bootgroup_carry.jpg",
      original: "/img/Bootgroup_carry.jpg",
      width: 465,
      height: 540,
    },
    {
      src: "/img/friscatnight.jpg",
      original: "/img/friscatnight.jpg",
      width: 465,
      height: 412,
    },
    {
      src: "/img/heigendhert.jpg",
      original: "/img/heigendhert.jpg",
      width: 465,
      height: 540,
    },
    {
      src: "/img/marsof.jpg",
      original: "/img/marsof.jpg",
      width: 465,
      height: 540,
    },
    {
      src: "/img/parajumping.jpg",
      original: "/img/parajumping.jpg",
      width: 464,
      height: 412,
    },
    {
      src: "/img/royalmarines.jpg",
      original: "/img/royalmarines.jpg",
      width: 465,
      height: 540,
    },
    {
      src: "/img/spelioladder.jpg",
      original: "/img/spelioladder.jpg",
      width: 465,
      height: 412,
    },
  ],
};

// FAQ Data
// src/data/data.js

export const faqDataNL = [
  {
    vraag: "Moet ik al superfit zijn om te beginnen?",
    antwoord:
      "Nee. Je hoeft geen topatleet te zijn. Dit programma geeft richting aan je voorbereiding en helpt je stap voor stap bouwen aan kracht, conditie, herstel en belastbaarheid. Wel moet je bereid zijn om consistent te trainen, eerlijk te schalen en pijnsignalen serieus te nemen.",
  },
  {
    vraag: "Kan ik dit combineren met werk of school?",
    antwoord:
      "Ja. Je traint zelfstandig op jouw eigen tijd. De sessies zijn functioneel opgebouwd zodat je consistent kunt blijven, ook met een drukke agenda. Verwacht wél toewijding - juist dat maakt het waardevol.",
  },
  {
    vraag: "Wat als ik twijfels heb of ik geschikt ben?",
    antwoord:
      "Twijfel is normaal. Juist daarom is dit programma waardevol. Het geeft je een eerlijke inkijk in de eisen, zodat je kunt voelen of je écht klaar bent voor deze stap.",
  },
  {
    vraag: "Wat als ik twijfel of mijn lichaam dit aankan?",
    antwoord:
      "Twijfel is normaal, maar pijnsignalen moet je serieus nemen. Bij terugkerende pijn, eerdere zware blessures, hart- of longklachten, duizeligheid, ernstige vermoeidheid of twijfel over je belastbaarheid is het verstandig eerst advies te vragen aan een arts, fysiotherapeut of coach. Als je twijfelt tussen zelfstandig starten of begeleiding, kies dan eerder voor begeleiding.",
  },
  {
    vraag: "Ik sport al - heb ik dit programma wel nodig?",
    antwoord:
      "Zelf trainen is waardevol. Militaire voorbereiding vraagt om presteren onder druk, omgaan met vermoeidheid, herstel en mentale focus. Dit programma geeft richting aan je training en helpt je opbouw aansluiten op wat straks gevraagd wordt.",
  },
  {
    vraag: "Is dit ook geschikt voor vrouwen?",
    antwoord:
      "Zeker. Steeds meer vrouwen kiezen bewust voor fysieke en mentale uitdaging. Dit programma is ontworpen voor iedereen met discipline, focus en drive - ongeacht geslacht.",
  },
];


// program details
export const programDetails = [
  {
    title: "Het Fundament",
    description:
      "De basis van het militaire handboek: doel, opbouw, verwachtingen en hoe je de 12-weekse voorbereiding gebruikt.",
  },
  {
    title: "Onderdeel 01: Basisvereisten",
    description:
      "De fysieke en mentale basis waar je aan werkt richting keuring, selectie, opleiding en de belasting daarna.",
  },
  {
    title: "Onderdeel 02: Fundamentele kracht",
    description:
      "Krachttraining gericht op techniek, belastbaarheid en duurzame fysieke ontwikkeling.",
  },
  {
    title: "Onderdeel 03: Zwemmen & watervertrouwen",
    description:
      "Zwemtraining, techniek en watervertrouwen voor kandidaten waarbij wateronderdelen relevant zijn.",
  },
  {
    title: "Onderdeel 04: Exercise Library",
    description:
      "Een oefenbibliotheek die je ondersteunt bij uitvoering, trainingskwaliteit en duidelijkheid in je sessies.",
  },
  {
    title: "Onderdeel 05: Mobility Guide",
    description:
      "Mobiliteit, herstel en richtlijnen om je lichaam beter voorbereid en belastbaar te houden.",
  },
];


export const reviews = [
  {
    name: "Luc, V",
    roleTitle: "Richting Korps Mariniers",
    trajectory: "Zelfstandig traject",
    text: "Ik trainde al veel maar meer gewoon wat ik dacht dat goed was. In dit programma werd duidelijk waar ik eigenlijk naartoe werkte. De extra testmomenten waren top om te zien hoe ik vooruit ging en daardoor ook gewoon weten dat ik de eisen kan halen.",
  },
  {
    name: "Milan, V",
    roleTitle: "Richting Politie",
    trajectory: "Persoonlijke begeleiding",
    text: "Ik had telkens last van mijn schenen zodra het hardlopen serieuzer werd. Justin keek niet alleen naar mijn loopvolume, maar ook naar herstel, kracht, techniek en hoe snel ik wilde opbouwen. Daardoor kon ik blijven trainen zonder elke keer weer terug naar nul te moeten.",
  },
  {
    name: "Jules, J",
    roleTitle: "Richting KMar",
    trajectory: "Zelfstandig traject",
    text: "Wat voor mij het meeste hielp, was de uitleg over hoe de opleiding eruit kan zien en wat je een beetje te wachten staat.",
  },
  {
    name: "Daan, K",
    roleTitle: "Richting Brandweer",
    trajectory: "Zelfstandig traject",
    text: "Zwaar, maar goed opgebouwd. Dat is denk ik de beste samenvatting.",
  },
  {
    name: "Bo, L",
    roleTitle: "Richting Korps Mariniers",
    trajectory: "Persoonlijke begeleiding",
    text: "Ik stuurde regelmatig filmpjes via whatsapp van mijn squat en deadlift. Dan kreeg ik gewoon terug waar ik op moest letten. Niet zo’n standaard antwoord, maar hij keek ook naar wat voor mijn lichaamsverhouding werkte.",
  },
  {
    name: "Jules, L",
    roleTitle: "Richting Korps Mariniers",
    trajectory: "Persoonlijke begeleiding",
    text: "Zwemmen met kleding aan was echt zuur. Ik raakte snel gespannen en wilde alles op kracht doen. De tips over rustiger ademen, beter drijven en minder vechten tegen het water hebben veel verschil gemaakt.",
  },
  {
    name: "Milan, H",
    roleTitle: "Richting KMar",
    trajectory: "Persoonlijke begeleiding",
    text: "Niet elke week ging perfect. Soms was ik moe, soms liep een training slecht en soms moest er iets worden aangepast. Voor mij was eten lastig, Justin had tips gedeeld zodat ik hier beter op kon letten en hierna ging dat beter.  Dat vond ik juist sterk aan de begeleiding.",
  },
  {
    name: "Liam, K",
    roleTitle: "Richting Politie",
    trajectory: "Persoonlijke begeleiding",
    text: "De live calls waren direct en eerlijk. Je merkt snel of je ergens omheen draait. Dat was soms confronterend, maar precies wat ik nodig had.",
  },
  {
    name: "Tom, R",
    roleTitle: "Richting Korps Mariniers",
    trajectory: "Persoonlijke begeleiding",
    text: "Voor mijn keuring had ik vooral behoefte aan feedback. Ik kon wel hardlopen en push-ups, maar vroeg me af hoe dat zou gaan met balken, mensen tillen en dat soort werk. Het krachtblok en de hele trainingsindeling hebben me fysiek sterker gemaakt. Ik weet nu ook beter wat ik moet doen wanneer ik train.",
  },
  {
    name: "Niels, K",
    roleTitle: "Richting Korps Mariniers",
    trajectory: "Zelfstandig traject",
    text: "De trainingen zijn gewoon zwaar. Verwacht geen schema dat je er even naast doet.",
  },
  {
    name: "Ruben, S",
    roleTitle: "Richting KMar",
    trajectory: "Persoonlijke begeleiding",
    text: "Ik vond vooral de app begeleiding fijn. Als ik twijfelde over een oefening kon ik het meteen vragen.",
  },
  {
    name: "Koen, M",
    roleTitle: "Richting Politie",
    trajectory: "Zelfstandig traject",
    text: "Ik had eerder losse schema’s geprobeerd, maar daar miste ik context. Hier snapte ik beter waarom bepaalde trainingen erin zaten en wanneer ik moest pushen of juist gas terug moest nemen.",
  },
  {
    name: "Timo, R",
    roleTitle: "Richting Brandweer",
    trajectory: "Persoonlijke begeleiding",
    text: "De techniekfeedback via video was echt handig. Kleine dingen in mijn houding maakten veel verschil, vooral bij deadlifts en lunges. Dat had ik zelf niet gezien.",
  },
];